import { useState } from 'react';
import { Box, Table, Thead, Tbody, Tr, Th, Td, Text, Input } from "@chakra-ui/react";
import { chakra } from '@chakra-ui/react';
import useEthereumPrice from '../hooks/useEthereumPrice';

const initialData = [
	{ id: 1, protocol: 'Wallet', activity: 'Holding', marks: 0.00271, boost: 'x1.00' },
	{ id: 2, protocol: 'Pencil', activity: 'Holding', marks: 0.00271, boost: 'x1.00' },
	{ id: 3, protocol: 'Ambient', activity: 'LP wrsETH / ETH (ambient)', marks: 0.00027, boost: 'x0.10' },
	{ id: 4, protocol: 'Ambient', activity: 'LP wrsETH / ETH (10%)', marks: 0.00414, boost: 'x1.53' },
	{ id: 5, protocol: 'Ambient', activity: 'LP wrsETH / ETH (0.1%)', marks: 0.00415, boost: 'x1.53' },
	{ id: 6, protocol: 'Ambient', activity: 'LP ETH / USDC (0.1%)', marks: 0.00921, boost: 'x3.40' },
	{ id: 7, protocol: 'Ambient', activity: 'LP USDC / USDT (0.5%)', marks: 0.00409, boost: 'x1.51' },
	{ id: 8, protocol: 'Nuri', activity: 'LP weETH / ETH (0.3%) Wide 5 ticks', marks: 0.00412, boost: 'x1.52' },
	{ id: 9, protocol: 'Rho Markets', activity: 'Supply ETH, 100%', marks: 0.00413, boost: 'x1.53' },
	{ id: 10, protocol: 'AAVE', activity: 'Supply ETH, 100%', marks: 0.00416, boost: 'x1.54' },
];

const ScrollMarksTable = () => {
	const [protocolInputs, setProtocolInputs] = useState(
		initialData.reduce((acc, { id }) => ({ ...acc, [id]: '' }), {})
	);
	const [selectedDays, setSelectedDays] = useState(1); // Default to 1 day
	const { priceData, loading, error } = useEthereumPrice();


	const handleInputChange = (id, value) => {
		setProtocolInputs((prev) => ({
			...prev,
			[id]: value
		}));
	};

	const calculateTotal = (id, marks) => {
		const input = parseFloat(protocolInputs[id]) || 0;
		return (input * marks * selectedDays).toFixed(3);
	};

	const calculateTotalInputAmount = () => {
		let totalInput = 0;
		initialData.forEach(row => {
			const input = parseFloat(protocolInputs[row.id]) || 0;
			totalInput += input;
		});
		return totalInput.toFixed(2);
	};

	const calculateTotalPerDay = () => {
		let total = 0;
		initialData.forEach(row => {
			const input = parseFloat(protocolInputs[row.id]) || 0;
			total += input * row.marks * selectedDays;
		});
		return total.toFixed(3);
	};

	const handleDayClick = (days) => {
		setSelectedDays(days);
	};

	return (
		<Box pt={6}>
			<Box mb={6} textAlign="center" fontSize="sm" >
				<Text
					as="span"
					mx={2}
					cursor="pointer"
					fontWeight={selectedDays === 1 ? 'bold' : 'normal'}
					color={selectedDays === 1 ? '#FF684B' : 'black'}
					onClick={() => handleDayClick(1)}
				>
					1 day
				</Text>
				|
				<Text
					as="span"
					mx={2}
					cursor="pointer"
					fontWeight={selectedDays === 7 ? 'bold' : 'normal'}
					color={selectedDays === 7 ? '#FF684B' : 'black'}
					onClick={() => handleDayClick(7)}
				>
					7 days
				</Text>
				|
				<Text
					as="span"
					mx={2}
					cursor="pointer"
					fontWeight={selectedDays === 30 ? 'bold' : 'normal'}
					color={selectedDays === 30 ? '#FF684B' : 'black'}
					onClick={() => handleDayClick(30)}
				>
					30 days
				</Text>
			</Box>

			<Box overflowX="auto">  {/* Make table scrollable on mobile */}
				<Table variant="simple" size="sm">
					<Thead>
						<Tr>
							<Th p={2} fontSize="sm">Protocol</Th>
							<Th p={2} fontSize="sm">Activity</Th>
							<Th p={2} fontSize="sm" textAlign='center'>Boost to Holding</Th>
							<Th p={2} fontSize="sm" textAlign='center'>Marks per 1 day/1$</Th>
							<Th p={2} fontSize="sm">Enter amount $</Th>
							<Th p={2} fontSize="sm" textAlign='center' width="200px">Total for {selectedDays} day{selectedDays > 1 ? 's' : ''}</Th>
						</Tr>
					</Thead>
					<Tbody>
						{initialData.map((row) => (
							<Tr key={row.id}>
								<Td p={2} fontWeight={"bold"} fontSize="sm">{row.protocol}</Td>
								<Td p={2} fontSize="sm">{row.activity}</Td>
								<Td p={2} fontSize="sm" textAlign='center'>{row.boost}</Td>
								<Td p={2} fontSize="sm" textAlign='center'>{row.marks}</Td>
								<Td p={2}>
									<Input
										value={protocolInputs[row.id] || ''}
										onChange={(e) => handleInputChange(row.id, e.target.value)}
										placeholder="0"
										type="number"
										min="0"
										step="any"
										size="sm"
										fontSize="sm"
										border="0px solid rgb(255, 104, 75)"
										outline="1px solid rgb(255, 104, 75)"
										_focus={{
											borderColor: "rgb(255, 104, 75)",
											outline: "1px solid rgb(255, 104, 75)"
										}}
									/>
								</Td>
								<Td p={2} fontSize="sm" textAlign='center'>{calculateTotal(row.id, row.marks)}</Td>
							</Tr>
						))}
						<Tr height={"70px"}>
							<Td colSpan={5} p={2} border="none" >
								<Text fontWeight="bold" fontSize="md">
									Your <chakra.span color={"#FF684B"}>${calculateTotalInputAmount()} / {!loading && (calculateTotalInputAmount() / priceData.USD).toFixed(2)} eth</chakra.span> for <chakra.span color={"#FF684B"}>{selectedDays} day{selectedDays > 1 ? 's' : ''}</chakra.span>  will give you
								</Text>
							</Td>
							<Td p={2} textAlign='center' border="none">
								<Text fontWeight="bold" fontSize="md">{calculateTotalPerDay()} marks</Text>
							</Td>
						</Tr>
					</Tbody>
				</Table>
			</Box>
		</Box>
	);
};

export default ScrollMarksTable;
